import {useMutation} from "@tanstack/react-query";

import {removeLeadContactMutationOptions} from "./remove-lead-contact.mutation-options";

export function useRemoveLeadContact(leadId: string) {
  return useMutation(removeLeadContactMutationOptions(leadId));
}
